import { Typography } from '@mui/material'

interface NoteTextProps {
  title?: string
  text?: string
}

export function TextWithLinks(props: NoteTextProps) {
  if (!props.text) return <></>
  const textWithLinks = props.text
  const parts = textWithLinks.includes('http')
    ? textWithLinks.split(/(https?:\/\/\S+)/)
    : [textWithLinks]
  console.log(props)

  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.stopPropagation()
    event.preventDefault()
    const url = event.currentTarget.href
    window.open(url, '_blank', 'noopener,noreferrer')
  }
  return (
    <>
      {parts.map((part, index) => {
        if (part.match(/https?:\/\/\S+/)) {
          return (
            <a
              key={index}
              href={part}
              target="_blank"
              rel="noopener noreferrer"
              onClick={handleClick}
            >
              {props.title ?? part}
            </a>
          )
        }
        return part
      })}
    </>
  )
}
